import axios from "axios";
import { MainUrl } from "../constants";

const API_URL = `${MainUrl}/shift`;

export const addShift = async (token, templateShiftId, employee) => {
  try {
    const bodyRequest = {
      template_shift_id: templateShiftId,
      employee: employee,
    };

    const response = await axios.post(`${API_URL}/`, bodyRequest, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.status == 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("access_level");
      window.location.href = "/";
    }
    return error.response.data;
  }
};

export const AddForeignShift = async (token, templateShiftId, employee) => {
  try {
    const bodyRequest = {
      template_shift_id: templateShiftId,
      employee: employee,
    };

    const response = await axios.post(`${API_URL}/forign_shift/`, bodyRequest, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.status == 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("access_level");
      window.location.href = "/";
    }
    return error.response.data;
  }
};

export const addOpenShift = async (token, date, employee, typeShiftId) => {
  const bodyRequest = {
    date: date,
    employee: employee,
    type_shift_id: typeShiftId,
  };
  try {
    const response = await axios.post(`${API_URL}/open_shift/`, bodyRequest, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.status == 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("access_level");
      window.location.href = "/";
    }
    return error.response.data;
  }
};

export const addOpenShifts = async (
  token,
  employee,
  startDate,
  endDate,
  typeShiftId
) => {
  try {
    const response = await axios.post(
      `${API_URL}/open_shift_many/`,
      {
        employee,
        start_date: startDate,
        end_date: endDate,
        type_shift_id: typeShiftId,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.status == 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("access_level");
      window.location.href = "/";
    }
    return error.response?.data;
  }
};

export const addInternShift = async (token, date, employee, fixUser) => {
  const bodyRequest = {
    date: date,
    employee: employee,
    fix_employee: fixUser,
  };
  try {
    const response = await axios.post(`${API_URL}/intern_shift/`, bodyRequest, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.status == 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("access_level");
      window.location.href = "/";
    }
    return error.response.data;
  }
};

export const addInternShifts = async (
  token,
  employee,
  fixEmployee,
  startDate,
  endDate
) => {
  try {
    const response = await axios.post(
      `${API_URL}/intern_shift_many/`,
      {
        employee,
        fix_employee: fixEmployee,
        start_date: startDate,
        end_date: endDate,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.status == 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("access_level");
      window.location.href = "/";
    }
    return error.response?.data;
  }
};

export const DeleteShift = async (token, shiftId) => {
  try {
    const response = await axios.delete(`${API_URL}/${shiftId}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.status == 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("access_level");
      window.location.href = "/";
    }
    return error.response.data;
  }
};

export const DeleteShifts = async (token, ids) => {
  try {
    const response = await axios.post(
      `${API_URL}/delete_many/`,
      { ids },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.status == 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("access_level");
      window.location.href = "/";
    }
    return error.response?.data;
  }
};

export const userShift = async (token, userId, startDate, endDate) => {
  try {
    let bodyRequest = {
      user_id: userId,
      start_date: startDate,
      end_date: endDate,
    };
    const response = await axios.post(`${API_URL}/user_shift/`, bodyRequest, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.status == 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("access_level");
      window.location.href = "/";
    }
    return error.response.data;
  }
};

export const GetuserShiftByDate = async (token, userId, date) => {
  try {
    let bodyRequest = {
      user_id: userId,
      date: date,
    };
    const response = await axios.post(
      `${API_URL}/user_shifts_by_date/`,
      bodyRequest,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.status == 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("access_level");
      window.location.href = "/";
    }
    return error.response.data;
  }
};

export const getShiftByTemplateShift = async (token, templateShiftId) => {
  try {
    const response = await axios.get(
      `${API_URL}/template_shift/${templateShiftId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.status == 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("access_level");
      window.location.href = "/";
    }
    return error.response.data;
  }
};

export const getShiftById = async (token, shiftId) => {
  try {
    const response = await axios.get(`${API_URL}/${shiftId}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.status == 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("access_level");
      window.location.href = "/";
    }
    return error.response.data;
  }
};

export const RestaurantShift = async (
  token,
  startDate,
  endDate,
  restaurantId
) => {
  try {
    let bodyRequest = {
      restaurant_id: restaurantId,
      start_date: startDate,
      end_date: endDate,
    };
    const response = await axios.post(
      `${API_URL}/restaurant_shift/`,
      bodyRequest,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.status == 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("access_level");
      window.location.href = "/";
    }
    return error.response.data;
  }
};


export const GetFilterShifts = async (
  token,
  filterURL
) => {
  try {
    // let bodyRequest = {
    //   shift_id: shiftId,
    //   date: date,
    //   employee: employee,
    //   creater: creater
    // };
    const response = await axios.get(
      `${API_URL}/get_query_shift/${filterURL}`,
      // bodyRequest,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.status == 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("access_level");
      window.location.href = "/";
    }
    return error.response.data;
  }
};